export const recommendTags = [
  "全部",
  "古装电影",
  "文艺改编",
  "系列影片",
  "电视剧",
  "戏曲舞台",
  "网络影像",
];

export const recommendItems = [
  {
    id: "rec-1",
    title: "《潘金莲之前世今生》",
    tag: "文艺改编",
    era: "1989年",
    desc:
      "以轮回结构重写人物，把古典故事放进现代都市，适合想看人物心理与社会处境、而非单纯情节的观众。",
    image:
      "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20poster%20illustration%20of%20a%20lone%20figure%20in%20a%20modern%20city%20alley%2C%20warm%20paper%20texture%2C%20muted%20vermillion%20and%20gold%20tones%2C%20poetic%20mood%2C%20no%20text%2C%20vertical%20composition&width=600&height=800&seq=pjl-rec-1&orientation=portrait",
    alt: "文艺改编方向的推荐示意图",
  },
  {
    id: "rec-2",
    title: "片厂古装片方向",
    tag: "古装电影",
    era: "20世纪60—70年代",
    desc:
      "古装片厂时期的作品，布景与戏曲感浓厚，适合对老电影质感与旧式叙事感兴趣的观众。",
    image:
      "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20poster%20illustration%20of%20a%20traditional%20pavilion%20and%20stone%20bridge%2C%20warm%20paper%20texture%2C%20muted%20vermillion%20and%20gold%20tones%2C%20retro%20film%20feel%2C%20no%20text%2C%20vertical%20composition&width=600&height=800&seq=pjl-rec-2&orientation=portrait",
    alt: "古装电影方向的推荐示意图",
  },
  {
    id: "rec-3",
    title: "九十年代系列影片",
    tag: "系列影片",
    era: "1990年代",
    desc:
      "系列化作品节奏明快、续集不断，适合按系列顺序浏览，感受同题材在不同阶段的处理差异。",
    image:
      "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20poster%20illustration%20of%20stacked%20film%20posters%20and%20lanterns%2C%20warm%20paper%20texture%2C%20muted%20vermillion%20and%20gold%20tones%2C%20lively%20retro%20mood%2C%20no%20text%2C%20vertical%20composition&width=600&height=800&seq=pjl-rec-3&orientation=portrait",
    alt: "系列影片方向的推荐示意图",
  },
  {
    id: "rec-4",
    title: "长篇电视剧版本",
    tag: "电视剧",
    era: "1990—2010年代",
    desc:
      "以剧集容量展开人物关系，支线完整、细节丰富，适合想系统了解故事背景与群像的观众。",
    image:
      "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20poster%20illustration%20of%20a%20courtyard%20gate%20and%20lantern%20light%2C%20warm%20paper%20texture%2C%20muted%20vermillion%20and%20gold%20tones%2C%20long%20story%20mood%2C%20no%20text%2C%20vertical%20composition&width=600&height=800&seq=pjl-rec-4&orientation=portrait",
    alt: "电视剧版本的推荐示意图",
  },
  {
    id: "rec-5",
    title: "地方剧种的舞台版本",
    tag: "戏曲舞台",
    era: "不同年代",
    desc:
      "以唱腔和身段塑造人物，多带有为人物翻案的视角，适合对传统戏曲与舞台表达有兴趣的观众。",
    image:
      "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20poster%20illustration%20of%20an%20opera%20performer%20in%20flowing%20sleeves%2C%20warm%20paper%20texture%2C%20muted%20vermillion%20and%20gold%20tones%2C%20theatrical%20elegance%2C%20no%20text%2C%20vertical%20composition&width=600&height=800&seq=pjl-rec-5&orientation=portrait",
    alt: "戏曲舞台方向的推荐示意图",
  },
  {
    id: "rec-6",
    title: "网络影像与短剧",
    tag: "网络影像",
    era: "近年",
    desc:
      "篇幅短、更新快，借用人物名号进行轻量演绎，适合碎片时间浏览，了解当代改编的新形态。",
    image:
      "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20poster%20illustration%20of%20a%20phone%20screen%20glowing%20beside%20a%20tea%20cup%2C%20warm%20paper%20texture%2C%20muted%20vermillion%20and%20gold%20tones%2C%20modern%20quiet%20mood%2C%20no%20text%2C%20vertical%20composition&width=600&height=800&seq=pjl-rec-6&orientation=portrait",
    alt: "网络影像方向的推荐示意图",
  },
];